'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult() {
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult as $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult as $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult };
$h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Based-On-Result.js.map
